<template>
 <div v-if="show" @click="closeModal" class="modal show   fixed top-0 left-0  w-full h-full outline-none overflow-x-hidden overflow-y-auto "  tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered relative w-auto pointer-events-none">
 <div class="relative top-20 mx-auto w-96 rounded-md   bg-white p-5 shadow-2xl border-2 "
      :class="postmessage.type=='success'?'border-green-400':'border-red-300 '">
     <div>
         <button class="float-right -mt-3 -mr-2  h-6 w-6 rounded-full border border-blue-500 "
                 @click="closeModal">
             X
         </button>
     </div>
  <div class="mt-3 text-center">
    <div v-if="postmessage.type=='success'" class="mx-auto flex h-12 w-12
          items-center justify-center rounded-full bg-green-500">
      <svg class="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
    </div>

    <div v-else-if="postmessage.type=='error'" class="mx-auto flex h-12
     w-12 items-center justify-center rounded-full bg-red-500">
      <svg class="h-6 w-6 text-white" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </div>

    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ postmessage.title }}</h3>
    <div class="mt-2 px-7 py-3">
      <p class="text-sm text-gray-500">{{postmessage.message}}</p>
    </div>
  </div>
</div>
</div>
</div>
 
</template>

<script>
export default {
name:'postPopup',

props:['postmessage'],
data: () => ({
 show:true,
}),
methods:{
    closeModal(){
        this.$emit('close', false)
    },
    closeInside(){
        this.show=false
    }
},
    mounted() {
//        setTimeout(() => {
//            this.closeModal();
//        }, 4000)
    },
}
</script>

<style>

</style>
<!-- <postPopup  v-if="postmessage.show" :postmessage="postmessage" @close="postmessage.show=!postmessage.show" /> -->

 <!-- this.postmessage={
                show:true,
                type:'save',
                title:'Login Information Error',
                message:'Please make sure username or password or server valid'
            } -->